import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const TIME_FORMATS = ["HH:mm:ss", "HH:mm", "hh:mm A", "h:mm A"];

export function formatEventDate(date) {
  if (!date) return "";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format("ddd D MMM") : "";
}

export function formatEventTime(time) {
  if (!time) return "";
  const parsed = dayjs(time, TIME_FORMATS, true);
  if (parsed.isValid()) return parsed.format("hh:mm A");

  const fallback = dayjs(time);
  return fallback.isValid() ? fallback.format("hh:mm A") : "";
}

/**
 * Converts a UTC event date & time to the event's target timezone (e.g. Asia/Kolkata)
 * and returns it formatted as specified.
 */
export function getConvertedEventDateTime(date, time, eventTz = "Asia/Kolkata", outFormat = "DD MMM hh:mm A") {
  if (!date) return "";
  const eventDateTimeStr = `${date} ${time || "00:00:00"}`.trim();
  const formats = [
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DD hh:mm A",
    "YYYY-MM-DD hh:mm:ss A",
    "YYYY-MM-DD",
  ];

  const parsed = dayjs(eventDateTimeStr, formats, true);
  if (!parsed.isValid()) {
    const fallback = dayjs(date);
    return fallback.isValid() ? fallback.format(outFormat) : date;
  }

  const converted = dayjs.tz(
    parsed.format("YYYY-MM-DD HH:mm:ss"),
    eventTz || "Asia/Kolkata",
  );
  if (!converted.isValid()) return date;

  return converted.format(outFormat);
}

/**
 * Parses a datetime (handling UTC ISO strings and UTC MySQL strings like 'YYYY-MM-DD HH:mm:ss')
 * and returns it formatted in the user's local timezone.
 */
export function formatDateTime(rawDate, format = "DD MMM YYYY, hh:mm A") {
  if (!rawDate) return "—";

  let d;
  if (typeof rawDate === "string") {
    const trimmed = rawDate.trim();
    if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(trimmed)) {
      d = dayjs.utc(trimmed.replace(" ", "T"));
    } else {
      d = dayjs(trimmed);
    }
  } else {
    d = dayjs(rawDate);
  }

  if (!d.isValid()) return "—";
  return d.local().format(format);
}
